import { useLocation } from "react-router-dom";

export const ErrorPage = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const error = query.get("message");

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-neutral-900">
      <h1 className="mb-5 text-red-400 text-lg">
        {error || "Unknown error occurred"}
      </h1>
      <a className="mt-5 text-white text-sm" href="/">Back to home</a>
    </div>
  );
};
